import styled from 'styled-components';
import Colors from 'assets/Colors';

const ItemWrapper = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 58px;
  font-weight: 500;
  font-size: 13px;
  position: relative;
  cursor: pointer;
  ${(props) => props.selected && `background: ${Colors.background_soft};`}
`;

const Line = styled.div`
  height: 100%;
  width: 3px;
  background: ${Colors.primary_web};
  right: 0;
  position: absolute;
`;

export default { ItemWrapper, Line };
